'use client';

import { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import type { AnimationItem } from 'lottie-web';
import { useLottieAnimation } from 'hooks/animation/useLottieAnimation';
import { useTranslations } from 'next-intl';
import styles from './LocationAccessPopup.module.css';

export const LocationAccessComponentDiv = ({
  className,
  setFlow,
  setUserLoc,
}: {
  className?: string;
  setFlow?: Dispatch<SetStateAction<string | null>>;
  setUserLoc?: Dispatch<SetStateAction<GeolocationPosition | null>>;
}) => {
  const t = useTranslations('common');
  const animContainerRef = useRef<HTMLDivElement>(null);
  const animationRef = useRef<AnimationItem | null>(null);

  function showPosition(position: GeolocationPosition) {
    if (setUserLoc && setFlow) {
      setUserLoc(position);

      setFlow('LOCATION_PERMISSION_GIVEN');
    }
  }

  useEffect(() => {
    if (animationRef) {
      animationRef.current?.stop();
    }
  }, []);

  useLottieAnimation(animContainerRef, {
    path: '/Precise-location-animation.json',
    renderer: 'svg',
    loop: true,
    autoplay: false,
    onInstance: (animation: AnimationItem) => {
      animationRef.current = animation;
    },
  });

  function getLocation(e: React.MouseEvent<HTMLButtonElement>) {
    console.log(e.target);
    if (e?.target) {
      (e.target as HTMLButtonElement).disabled = true;
      animationRef.current?.play();
    }

    if (window?.navigator) {
      window.navigator.geolocation.getCurrentPosition(
        (position: GeolocationPosition) => {
          showPosition(position);
        },
        (error: GeolocationPositionError) => {
          console.log(error);
          if (setUserLoc && setFlow) {
            setUserLoc(null);
            setFlow('LOCATION_PERMISSION_DENIED');
          }
        },
        {
          timeout: 10000,
        },
      );
    }
  }

  return (
    <div className={[styles.root, className].filter(Boolean).join(' ')}>
      <div className={styles.locationImgContainer}>
        <div className={styles.tracker} ref={animContainerRef}>
          {/* <Image src="/locationTrack.png" alt="tracker-img" fill /> */}
        </div>
        {/* <Image
                  src="/locationTrack.png"
                  alt="uber-img"
                  width={190}
                  height={190}
                  style={{
                    position: 'relative',
                    top: '0.4rem',
                  }}

                /> */}
      </div>
      <div className={styles.locationContentContainer}>
        <h3>{t('locationAccessPopup.subheading.weNeedAccess')}</h3>
        <p>{t('locationAccessPopup.text.pleaseGrantLocation')}</p>
        <button
          className={`${styles.cta} ${styles.primary}`}
          onClick={getLocation}
        >
          {t('locationAccessPopup.button.gotIt')}
        </button>
      </div>
    </div>
  );
};
